import { Component, h, State, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'biel-search-filters',
  styleUrl: 'biel-search-filters.css',
  shadow: true,
})
export class BielSearchFilters {
  @Prop() filters: { title: string }[] = [];
  @Prop() disableFilters: boolean = false;

  @State() selectedFilter: number = 0;
  @Event() filterSelected: EventEmitter<string>;

  handleFilterClick(position: number, selectedFilter: string) {
    if (this.selectedFilter !== position) {
      this.selectedFilter = position;
      this.filterSelected.emit(selectedFilter);
    }
  }

  render() {
    return (
      <div class="biel-search-filters" part="container">
        <button
          key={0}
          class={`filter-button ${this.selectedFilter === 0 ? 'selected' : ''}`}
          part="filter-button"
          onClick={() => this.handleFilterClick(0, '')}
        >
          All
        </button>
        {this.filters.map((filter, index) => (
          <button
            key={`${filter.title}-${index}`}
            class={`filter-button ${this.selectedFilter === index + 1 ? 'selected' : ''}`}
            part="filter-button"
            onClick={() => this.handleFilterClick(index + 1, filter.title)}
          >
            {filter.title}
          </button>
        ))}
      </div>
    );
  }
}
